import React from "react";
import { FormattedMessage } from "react-intl";

//
function BankDetailsDepositHeader(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> {
  return (
    <div className="bank-details__header">
      <div className="bank-details__header__info">
        <FormattedMessage tagName="span" id="cashier-toplaceabankwire" />
        {' "'}
        {props.user["currencyCode"]}
        {'" '}
        <FormattedMessage tagName="span" id="cashier-followbankdetails" />
      </div>
      <div className="bank-details__header__label">
        <FormattedMessage tagName="span" id="cashier-bankdetailslabel" />
      </div>
    </div>
  );
}

export default BankDetailsDepositHeader;
